import api from "../../api/apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      params.append(key, p[key]);
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  cards(p) {
    return api.get(`/api/v1/statistics/total-today`);
  },
  attendance10DaysAgo(p) {
    return api.get(`/api/v1/statistics/attendance`);
  },
  usersDayOff(data) {
    return api.get(`/api/v1/statistics/day-off`, data);
  },
  leaveApps(p) {
    return api.get(`/api/v1/statistics/leave-apps`);
  },
  importExcel(data) {
    return api.post(`/api/v1/import-client`, data);
  },
  downloadExcel() {
    return api.get(`/api/v1/get-admins`, {
      responseType: "blob",
    });
  },
  checkDownloadExcelStatus() {
    return api.get(`/api/v1/get-status`);
  },
  getAvgAttendanceHoursDetails(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/statistics/avg-working-hours?${p}`);
  },
};
